const elements = document.querySelectorAll('.grouped-inputs');

elements.forEach(function (element) {
    const elementInputs = element.querySelectorAll('input, select');


    elementInputs.forEach(function (input) {
        input.addEventListener('focus', function () {
            element.classList.add('focused');
        })

        input.addEventListener('blur', function () {
            element.classList.remove('focused');
        })
    });

});


// textarea autoresize
const form_textareas_fields = document.querySelectorAll('[data-autoresize]');

function addAutoResize() {
  form_textareas_fields.forEach(function (element) {
    element.style.boxSizing = 'border-box';
    var offset = element.offsetHeight - element.clientHeight;
    element.addEventListener('input', function (event) {
      event.target.style.height = 'auto';
      event.target.style.height = event.target.scrollHeight + offset + 'px';
    });
    element.removeAttribute('data-autoresize');
  });
}

if (form_textareas_fields) {
	addAutoResize(form_textareas_fields);
}

// wetlab - country, prefix übergabe
const country_input = document.getElementById('countryDataList');
const country_datalist = document.getElementById('countryOptions');

const prefix_input = document.getElementById('vorwahlDataList');
const prefix_datalist = document.getElementById('vorwahlOptions');

if (country_input) {
  country_input.addEventListener('input', function () {
    //console.log(prefix_datalist.options.length);
    var pre_opt = prefix_datalist.querySelector('[data-code="'+ this.value +'"]');
    if (pre_opt) {
      //var pre_opt_val = pre_opt.dataset.code;
      prefix_input.value = pre_opt.value;
    }
  });
}